export default __webpack_public_path__ + "static/media/bacon.471c8b04.png";